import $ from 'jquery';

let removeButton = $('.js-dropzone-remove');
let revertButton = $('.js-revert-button');
let input = $('.js-add-image-caption');

removeButton.on('click', function () {
    $(this).closest('li').find(input).hide();
});

revertButton.on('click', function () {
    $(this).closest('li').find(input).show();
});

$(document).on('input', '.js-add-image-caption', function (e) {
    let current = $(this);
    $.ajax({
        type: "GET",
        url: "add-image-caption",
        data: {
          imageID : current.attr('data-dz-id'),
          caption : current.val(),
        },
        success: function (data) {
            console.log('successfully-added');
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log('fails');
        }
    });
});